import styled from "@emotion/styled";

export const Image = styled.img`
  &:before {
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='48' fill='${(
      props: any
    ) =>
      props.theme.colors.background.paper.replace(
        "#",
        "%23"
      )}' width='48'%3E%3Cpath  d='M24 34q.7 0 1.175-.475.475-.475.475-1.175 0-.7-.475-1.175Q24.7 30.7 24 30.7q-.7 0-1.175.475-.475.475-.475 1.175 0 .7.475 1.175Q23.3 34 24 34Zm-1.35-7.65h3V13.7h-3ZM24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 23.95q0-4.1 1.575-7.75 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24.05 4q4.1 0 7.75 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Zm.05-3q7.05 0 12-4.975T41 23.95q0-7.05-4.95-12T24 7q-7.05 0-12.025 4.95Q7 16.9 7 24q0 7.05 4.975 12.025Q16.95 41 24.05 41ZM24 24Z'/%3E%3C/svg%3E");
    align-items: center;
    background-color: ${(props: any) => props.theme.colors.typography.tertiary};
    box-sizing: border-box;
    color: ${(props: any) => props.theme.colors.background.paper};
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    padding-bottom: 24px;
    position: absolute;
    top: 0;
    width: 100%;
  }

  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;

  &:after {
    content: "Image not found";
    align-items: center;
    box-sizing: border-box;
    color: ${(props: any) => props.theme.colors.background.paper};
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    padding-top: 48px;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;
